/* Essenza v5 — carrega e toca vídeos curtos só quando aparecem na tela. */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var save = navigator.connection && navigator.connection.saveData;
  function init() {
    var vids = document.querySelectorAll('video.es-vid:not([data-es])');
    if (!vids.length || reduce || save || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (!v.getAttribute('src') && v.dataset.src) v.src = v.dataset.src;
          v.muted = true;
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { rootMargin: '150px', threshold: 0.25 });
    vids.forEach(function (v) { v.setAttribute('data-es', ''); io.observe(v); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Faixas com rolagem automática: avança devagar enquanto visíveis; para ao tocar/passar o mouse. */
(function () {
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function setup() {
    document.querySelectorAll('[data-es-auto]:not([data-es-on])').forEach(function (el) {
      el.setAttribute('data-es-on', '');
      var paused = false, visible = false, timer;
      function step() {
        if (paused || !visible) return;
        var tile = el.firstElementChild; if (!tile) return;
        var w = tile.getBoundingClientRect().width + 12;
        if (el.scrollLeft + el.clientWidth >= el.scrollWidth - 4) el.scrollTo({ left: 0, behavior: 'smooth' });
        else el.scrollBy({ left: w, behavior: 'smooth' });
      }
      ['touchstart', 'mouseenter', 'focusin', 'pointerdown'].forEach(function (ev) { el.addEventListener(ev, function () { paused = true; }, { passive: true }); });
      ['mouseleave'].forEach(function (ev) { el.addEventListener(ev, function () { paused = false; }); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0.3 }).observe(el);
      } else visible = true;
      timer = setInterval(step, 3500);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  document.addEventListener('shopify:section:load', setup);
})();

